module.exports = __webpack_public_path__ + "assets/img/wxewm.6a0616fb.png";